export default "__VITE_ASSET__6138643b__"